import { render, staticRenderFns } from "./Setpass.vue?vue&type=template&id=021cefd6&scoped=true&"
import script from "./Setpass.vue?vue&type=script&lang=js&"
export * from "./Setpass.vue?vue&type=script&lang=js&"
import style0 from "./Setpass.vue?vue&type=style&index=0&id=021cefd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cefd6",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Setpass.vue
// module id = null
// module chunks = 